// import { updateItems } from '../actions';

const minimumDt = 20;

export default class TaskList {

  constructor({dt}) {
    this.initialTime = null;
    this.dt = Math.max(dt, minimumDt);
    this.tasks = [];
    this.initialized = false;
    const that = this;
    this.Promise = new Promise((resolve, reject) => {
      that.resolve = resolve;
      that.reject = reject;
    });
  }

  getPromise() {
    return this.Promise;
  }

  addTask(task) {
    this.tasks.push(task);
  }

  setStartTimestamp(timeStamp) {
    this.initialTime = timeStamp;
  }

  updateItems(currentItems) {
    let items =[];
    let done = false;
    try {
      if (!this.initialized) {
        this.initialized = true;
        this.tasks.forEach(task => {
          const currentItem = currentItems.filter(item => item.id === task.item.id)[0];
          task.setCurrentItem(currentItem);
        });
      }
      let fraction = (Date.now() - this.initialTime) / this.dt;
      fraction = Math.min(fraction, 1);
      items = this.tasks.map(task => {
        return task.update(fraction);
      });
      done = fraction >= 1;
      if (done) {
        console.log('done', this.tasks);
        this.resolve();
      }
    } catch (ex) {
      this.reject(ex);
      done = true;
    }
    return { items, done};
  }

  execute() {
    return new Promise((resolve, reject) => {
      try {
        this.initialTime = Date.now();
        this.finalTime = this.initialTime + this.dt;
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  }
}